import type { ESignPackage, PackageStatus, Participant } from '../types/docmagic';

export const STAGES = ['created', 'started', 'consented', 'viewed', 'completed'] as const;
export type Stage = (typeof STAGES)[number];

export function isBorrowerRole(p: Participant): boolean {
  return p.role === 'Borrower' || p.role === 'Co-Borrower';
}

export function requiredSigners(pkg: ESignPackage): Participant[] {
  return pkg.participants.filter(
    (p) => isBorrowerRole(p) || (pkg.requireOriginatorCompletion && p.role === 'Originator'),
  );
}

export function allRequiredComplete(pkg: ESignPackage): boolean {
  const required = requiredSigners(pkg);
  return required.length > 0 && required.every((p) => p.completed !== null);
}

export function derivePackageStatus(pkg: ESignPackage): PackageStatus {
  if (pkg.syncStatus === 'Failed') return 'Sync Failed';
  if (pkg.participants.some((p) => p.declined !== null)) return 'Declined';
  if (allRequiredComplete(pkg)) {
    return pkg.pdfStatus === 'Stored' ? 'Completed' : 'Completed — PDF Pending';
  }
  const anyActivity = pkg.participants.some(
    (p) => p.started || p.consented || p.viewed || p.completed,
  );
  return anyActivity ? 'In Progress' : 'Pending';
}

export function stageIndex(p: Participant): number {
  let idx = -1;
  STAGES.forEach((s, i) => {
    if (p[s]) idx = i;
  });
  return idx;
}
